import styled from "styled-components";

export const ThemeBtn = styled.button`
    background-color: #ffff;
    border-radius: 10px;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 15px;
    position: fixed;
    bottom: 12px;
    right: 12px;
    
`;